export default {
  data() {
    return {
      searchSchema: [
        {
          itemName: 'parentCode',
          label: '母公司ID',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'parentName',
          label: '母公司名称',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'relationType',
          label: '关联类型',
          type: 'select',
          selectList: [
            {
              text: '关联共享',
              value: 1,
            },
            {
              text: '关联分配',
              value: 2,
            },
          ],
          allowClear: true,
        },
        {
          itemName: 'childCode',
          label: '子公司ID',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'childName',
          label: '子公司名称',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'applier',
          label: '申请人',
          type: 'input',
          allowClear: true,
        },
      ],
      searchData: {
        relationType: '',
        applier: '',
        childName: '',
        childCode: '',
        parentName: '',
        parentCode: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          slots: { title: 'customTitile' },
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '申请单号',
          dataIndex: 'bpmId',
          scopedSlots: { customRender: 'bpmId' },
          width: 150,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 150,
        },
        {
          title: '申请人',
          dataIndex: 'applyPerson',
          width: 150,
        },
        {
          title: '母公司ID',
          dataIndex: 'parentCode',
          width: 150,
        },
        {
          title: '母公司名称',
          dataIndex: 'parentName',
          width: 150,
        },
        {
          title: '分公司ID',
          dataIndex: 'childCode',
          width: 150,
        },
        {
          title: '分公司名称',
          dataIndex: 'childName',
          width: 150,
        },
        {
          title: '关联类型',
          dataIndex: 'relationTypeStr',
          width: 150,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 200,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
}
